var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfo = function SvgInfo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "info_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".info_svg__st0{fill:#414a5f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12C22.493 6.204 17.796 1.507 12 1.5M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0",
    className: "info_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.192 5.52a.98.98 0 0 0-1.023.932l-.001.076a.975.975 0 0 0 .957.993l.067-.001a.98.98 0 0 0 1.038-.918q.002-.037.002-.074a.98.98 0 0 0-1.04-1.008m.752 4.048h-1.472V18h1.472z",
    className: "info_svg__st0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export default ForwardRef;